import { Injector } from "@angular/core";
import { ErrorHandlerService } from './error-handler.service';
import * as i0 from "@angular/core";
/*
    NgErrorHandler.handleError will be called by angular but only on in-app exceptions.
    All custom code will inject ErrorHandlerService directly.
*/
export let NgErrorHandler = /*#__PURE__*/(() => {
  class NgErrorHandler {
    constructor(injector) {
      this.injector = injector;
    }
    handleError(error) {
      this.injector.get(ErrorHandlerService).handleError(error);
    }
    static {
      this.ɵfac = function NgErrorHandler_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgErrorHandler)(i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: NgErrorHandler,
        factory: NgErrorHandler.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgErrorHandler;
})();